import { Container } from "./styles";

import ScrollAnimation from "react-animate-on-scroll";

import cssIcon from "../../assets/css-icon.svg";
import htmlIcon from "../../assets/html-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import vueIcon from "../../assets/vue-icon.svg";
import angularIcon from "../../assets/angular-icon.svg";
import gatsbyIcon from "../../assets/gatsby.svg";
import nextIcon from "../../assets/next-js.svg";
import nuxtIcon from "../../assets/nuxt-js.svg";
import svelteIcon from "../../assets/svelte.svg";
import tailwindcssIcon from "../../assets/tailwindcss.svg";


export function About(){
  return(
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000}>
          <p>My name is Abdulnasır olcan, a frontend software engineer with great passion for programming.</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000} style={{marginTop: "2rem", marginBottom: "2rem"}}>

          <p>Software technologies are developing and expanding day by day. I follow new technologies and developments in the software world in order to keep up with this change.</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.6 * 1000}>

          <p>My goal is to be successful in my job by adding the experience I will gain from the company I will work with to my knowledge, to contribute to my improvement by taking part in new projects, getting new ideas and to gain new successes.</p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.8 * 1000} style={{marginTop: "2rem", marginBottom: "2rem"}}> 
          <p>Success comes with determination and persistence in achieving a goal.</p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <h3>Here are my main skills:</h3>
        </ScrollAnimation>
        <div className="hard-skills">


        <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}> 
            <img src={angularIcon} alt="Angular" />
          </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.3 * 1000}>
              <img src={reactIcon} alt="React" />
            </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}>
            <img src={vueIcon} alt="Vue" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.5 * 1000}>
            <img src={svelteIcon} alt="Svelte" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}> 
            <img src={nodeIcon} alt="Node" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.7 * 1000}> 
            <img src={nextIcon} alt="Nextjs" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.8 * 1000}> 
            <img src={nuxtIcon} alt="Nuxtjs" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.8 * 1000}> 
            <img src={gatsbyIcon} alt="Gatsby" />
          </ScrollAnimation>
          </div>


          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.9 * 1000}>
            <img src={typescriptIcon} alt="Typescript" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={1.0 * 1000}> 
            <img src={jsIcon} alt="JavaScript" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={1.1 * 1000}> 
            <img src={htmlIcon} alt="Html" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={1.2 * 1000}> 
            <img src={cssIcon} alt="Css" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={1.3 * 1000}>
            <img src={tailwindcssIcon} alt="Tailwindcss" />
          </ScrollAnimation>
          </div>


        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.6 * 1000}>
          <img src={`${require('../../assets/profile.jpg')}`} alt="profile" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}
